(function(){
  'use strict';
  var queued = false;
  var categories = [
    {label:'Vibradores', handle:'vibradores'},
    {label:'Succionadores', handle:'succionadores-de-clitoris'},
    {label:'Anal', handle:'sexo-anal'},
    {label:'Masturbadores', handle:'masturbadores'},
    {label:'Lencería', handle:'lenceria'},
    {label:'Lubricantes', handle:'lubricantes'},
    {label:'Bondage', handle:'bondage'},
    {label:'Dildos', handle:'dildos'}
  ];

  function isMobile(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function isCollectionPage(){
    return /^\/collections\/[^\/?#]+/.test(window.location.pathname || '');
  }

  function getCurrentCollectionHandle(){
    var match = (window.location.pathname || '').match(/^\/collections\/([^\/?#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function addStyles(){
    if (document.getElementById('erectus-mobile-sort-visible-styles')) return;
    var style = document.createElement('style');
    style.id = 'erectus-mobile-sort-visible-styles';
    style.textContent = [
      '@media (max-width:767px){',
      '.erectus-mobile-category-nav{display:block!important;margin:4px 0 12px!important;padding:0!important;}',
      '.erectus-mobile-category-title{font-size:16px!important;font-weight:700!important;line-height:1.25!important;margin:0 0 8px!important;color:#111!important;}',
      '.erectus-mobile-category-grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:7px!important;}',
      '.erectus-mobile-category-link{display:flex!important;align-items:center!important;justify-content:center!important;min-height:40px!important;padding:8px 7px!important;border:1px solid #e3e3e3!important;border-radius:8px!important;background:#fff!important;color:#222!important;font-size:12.5px!important;font-weight:600!important;line-height:1.2!important;text-align:center!important;text-decoration:none!important;box-sizing:border-box!important;}',
      '.erectus-mobile-category-link:hover,.erectus-mobile-category-link:focus{color:#222!important;text-decoration:none!important;}',
      '.erectus-mobile-category-link.is-active{border-color:#e60000!important;background:#fff4f4!important;color:#d90000!important;font-weight:700!important;}',
      '.erectus-mobile-category-link.is-active:hover,.erectus-mobile-category-link.is-active:focus{color:#d90000!important;}',
      '.erectus-mobile-category-more{display:flex!important;align-items:center!important;justify-content:center!important;min-height:38px!important;margin-top:7px!important;border:0!important;background:transparent!important;color:#d90000!important;font-size:13px!important;font-weight:700!important;text-decoration:none!important;}',
      '.erectus-mobile-category-more:hover,.erectus-mobile-category-more:focus{color:#d90000!important;text-decoration:underline!important;}',
      '.mobile-facets-container{display:flex!important;flex-wrap:wrap!important;gap:8px!important;align-items:flex-end!important;}',
      '.mobile-facets-container .mobile-facets__wrapper{flex:0 0 auto!important;order:1!important;}',
      '.erectus-mobile-sort-wrap{flex:1 1 150px!important;min-width:150px!important;max-width:220px!important;margin-left:auto!important;order:2!important;}',
      '.erectus-mobile-sort-label{display:block!important;font-size:11px!important;line-height:1.2!important;font-weight:700!important;margin:0 0 3px!important;color:#555!important;}',
      '.erectus-mobile-sort-select{display:block!important;width:100%!important;min-height:42px!important;padding:8px 30px 8px 10px!important;border:1px solid #e3e3e3!important;border-radius:8px!important;background:#fff!important;color:#111!important;font-family:inherit!important;font-size:13px!important;font-weight:600!important;box-sizing:border-box!important;}',
      '.mobile-facets-container .collection-product-count{flex:1 1 100%!important;order:3!important;font-size:12px!important;font-weight:500!important;opacity:.72!important;}',
      '}',
      '@media (max-width:380px){',
      '.erectus-mobile-category-link{font-size:12px!important;padding-left:5px!important;padding-right:5px!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensureCategoryNav(root){
    if (!isMobile() || !isCollectionPage()) return;
    var scope = root && root.querySelector ? root : document;
    var container = scope.querySelector('.mobile-facets-container') || document.querySelector('.mobile-facets-container');
    if (!container || !container.parentNode) return;

    addStyles();

    var existing = document.getElementById('erectus-mobile-category-nav');
    if (existing && existing.nextElementSibling === container) return;
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var nav = document.createElement('nav');
    nav.id = 'erectus-mobile-category-nav';
    nav.className = 'erectus-mobile-category-nav';
    nav.setAttribute('aria-label','Categorías de productos');

    var title = document.createElement('div');
    title.className = 'erectus-mobile-category-title';
    title.textContent = 'Explora por categoría';
    nav.appendChild(title);

    var grid = document.createElement('div');
    grid.className = 'erectus-mobile-category-grid';
    var current = getCurrentCollectionHandle();

    categories.forEach(function(category){
      var link = document.createElement('a');
      link.className = 'erectus-mobile-category-link';
      link.href = '/collections/' + category.handle;
      link.textContent = category.label;
      if (current === category.handle) {
        link.classList.add('is-active');
        link.setAttribute('aria-current','page');
      }
      grid.appendChild(link);
    });

    nav.appendChild(grid);

    var more = document.createElement('a');
    more.className = 'erectus-mobile-category-more';
    more.href = '/collections';
    more.textContent = 'Ver más categorías';
    nav.appendChild(more);

    container.parentNode.insertBefore(nav, container);
  }

  function exposeMobileSort(root){
    if (!isMobile()) return;
    var scope = root && root.querySelector ? root : document;
    var nativeSort = scope.querySelector('#SortBy-mobile') || document.querySelector('#SortBy-mobile');
    var container = scope.querySelector('.mobile-facets-container') || document.querySelector('.mobile-facets-container');
    if (!nativeSort || !container) return;

    addStyles();

    var existing = container.querySelector('.erectus-mobile-sort-wrap');
    if (existing) {
      var existingSelect = existing.querySelector('.erectus-mobile-sort-select');
      if (existingSelect && existingSelect.value !== nativeSort.value) existingSelect.value = nativeSort.value;
      return;
    }

    var wrap = document.createElement('div');
    wrap.className = 'erectus-mobile-sort-wrap';

    var label = document.createElement('label');
    label.className = 'erectus-mobile-sort-label';
    label.textContent = 'Ordenar';
    label.setAttribute('for','ErectusSortByMobile');

    var select = nativeSort.cloneNode(true);
    select.id = 'ErectusSortByMobile';
    select.name = '';
    select.className = 'erectus-mobile-sort-select';
    select.removeAttribute('aria-describedby');
    select.setAttribute('aria-label','Ordenar productos');
    select.addEventListener('change', function(){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    wrap.appendChild(label);
    wrap.appendChild(select);

    var count = container.querySelector('.collection-product-count');
    if (count) container.insertBefore(wrap, count);
    else container.appendChild(wrap);
  }

  function run(root){
    ensureCategoryNav(root || document);
    exposeMobileSort(root || document);
  }

  function queueRun(){
    if (queued || !isMobile()) return;
    queued = true;
    window.requestAnimationFrame(function(){
      queued = false;
      run(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      run(document);
      observe();
    });
  } else {
    run(document);
    observe();
  }

  document.addEventListener('shopify:section:load', function(e){ run(e.target || document); });
  document.addEventListener('collection:updated', function(){ run(document); });

  function observe(){
    var target = document.querySelector('.main-content-grid') || document.querySelector('.collections') || document.body;
    if (!target || target.getAttribute('data-erectus-sort-observer') === 'true') return;
    target.setAttribute('data-erectus-sort-observer','true');
    var observer = new MutationObserver(function(mutations){
      var changed = mutations.some(function(m){ return m.addedNodes && m.addedNodes.length; });
      if (changed) queueRun();
    });
    observer.observe(target,{childList:true,subtree:true});
  }
})();

(function(){
  'use strict';

  var homeFamilies = [
    {label:'Vibradores', handle:'vibradores', icon:'la-bolt', bg:'#f2d8f5'},
    {label:'Succionadores', handle:'succionadores-de-clitoris', icon:'la-wind', bg:'#d6f2eb'},
    {label:'Anal', handle:'sexo-anal', icon:'la-circle', bg:'#f7d8df'},
    {label:'Masturbadores', handle:'masturbadores', icon:'la-hand-pointer', bg:'#dbe9f7'},
    {label:'Lencería', handle:'lenceria', icon:'la-heart', bg:'#f7d9e7'},
    {label:'Lubricantes', handle:'lubricantes', icon:'la-tint', bg:'#d7edf7'},
    {label:'Bondage', handle:'bondage', icon:'la-link', bg:'#e2dcf6'},
    {label:'Dildos', handle:'dildos', icon:'la-star', bg:'#f6e4c9'}
  ];

  function isMobile(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function isHome(){
    var path = window.location.pathname || '/';
    return path === '/' || path === '';
  }

  function addHomeStyles(){
    if (document.getElementById('erectus-home-families-styles')) return;
    var style = document.createElement('style');
    style.id = 'erectus-home-families-styles';
    style.textContent = [
      '@media (max-width:767px){',
      '#erectus-home-families{display:block!important;margin:12px auto 22px!important;padding:0 10px!important;max-width:620px!important;box-sizing:border-box!important;}',
      '#erectus-home-families .ehf-title{margin:0 0 13px!important;text-align:center!important;color:#111!important;font-size:19px!important;font-weight:800!important;line-height:1.2!important;letter-spacing:.1px!important;}',
      '#erectus-home-families .ehf-grid{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:13px 8px!important;align-items:start!important;}',
      '#erectus-home-families .ehf-item{display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:flex-start!important;color:#222!important;text-decoration:none!important;text-align:center!important;min-width:0!important;}',
      '#erectus-home-families .ehf-icon{display:flex!important;align-items:center!important;justify-content:center!important;width:66px!important;height:66px!important;margin:0 auto 6px!important;border-radius:50%!important;box-sizing:border-box!important;box-shadow:0 3px 9px rgba(0,0,0,.09)!important;color:#1f1f1f!important;font-size:29px!important;line-height:1!important;}',
      '#erectus-home-families .ehf-icon i{font-size:29px!important;line-height:1!important;}',
      '#erectus-home-families .ehf-label{display:block!important;width:100%!important;min-height:28px!important;color:#222!important;font-size:11.7px!important;font-weight:650!important;line-height:1.15!important;overflow-wrap:anywhere!important;}',
      '#erectus-home-families .ehf-more{display:flex!important;align-items:center!important;justify-content:center!important;margin:9px auto 0!important;min-height:34px!important;color:#d90000!important;font-size:13px!important;font-weight:750!important;text-decoration:none!important;}',
      '#erectus-home-families .ehf-more:after{content:"›"!important;margin-left:5px!important;font-size:20px!important;line-height:1!important;}',
      '}',
      '@media (max-width:359px){',
      '#erectus-home-families .ehf-grid{grid-template-columns:repeat(3,minmax(0,1fr))!important;}',
      '#erectus-home-families .ehf-icon{width:62px!important;height:62px!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function buildHomeFamilies(){
    if (!isHome()) return;

    var old = document.querySelector('.cat-circles');
    var existing = document.getElementById('erectus-home-families');

    if (!isMobile()) {
      if (old) old.style.removeProperty('display');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      return;
    }

    if (!old || !old.parentNode) return;
    addHomeStyles();
    old.style.setProperty('display','none','important');
    if (existing) return;

    var section = document.createElement('section');
    section.id = 'erectus-home-families';
    section.setAttribute('aria-label','Explora por categoría');

    var title = document.createElement('h2');
    title.className = 'ehf-title';
    title.textContent = 'Explora por categoría';
    section.appendChild(title);

    var grid = document.createElement('div');
    grid.className = 'ehf-grid';

    homeFamilies.forEach(function(category){
      var link = document.createElement('a');
      link.className = 'ehf-item';
      link.href = '/collections/' + category.handle;
      link.setAttribute('aria-label', category.label);

      var icon = document.createElement('span');
      icon.className = 'ehf-icon';
      icon.style.backgroundColor = category.bg;
      icon.innerHTML = '<i class="las ' + category.icon + '" aria-hidden="true"></i>';

      var label = document.createElement('span');
      label.className = 'ehf-label';
      label.textContent = category.label;

      link.appendChild(icon);
      link.appendChild(label);
      grid.appendChild(link);
    });

    section.appendChild(grid);

    var more = document.createElement('a');
    more.className = 'ehf-more';
    more.href = '/collections';
    more.textContent = 'Ver todas las categorías';
    section.appendChild(more);

    old.parentNode.insertBefore(section, old.nextSibling);
  }

  var resizeTimer = null;
  function queueBuild(){
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(buildHomeFamilies, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildHomeFamilies);
  } else {
    buildHomeFamilies();
  }

  window.addEventListener('resize', queueBuild);
  document.addEventListener('shopify:section:load', queueBuild);
})();